import {formatMoney, throttle, debounce} from "//toleofficial.com/cdn/shop/t/47/assets/theme.js?v=181184729220953866381755094332";

 /*============================================================================
    CountdownTimer
  ==============================================================================*/
  
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.display = this.querySelector('[data-time-display]');
    this.block = this.closest('.countdown__block--timer');
    this.year = this.el.dataset.year;
    this.month = this.el.dataset.month;
    this.day = this.el.dataset.day;
    this.hour = this.el.dataset.hour;
    this.minute = this.el.dataset.minute;
    this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
    this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
    this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
    this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
    this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
    this.hideTimerOnComplete = this.el.dataset.hideTimer;
    this.completeMessage = this.el.dataset.completeMessage;

    this.timerComplete = false;

    this.init();
  }

  init() {
    setInterval(() => {
      if (!this.timerComplete) {
        this._calculate();
      }
    }, 1000);
  }

  _calculate() {
    // Find time difference and convert to integer
    const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
    // If time difference is greater than 0, calculate remaining time
    if (timeDifference > 0) {
      const intervals = {
        days: this._formatNumber(Math.floor(timeDifference / (1000 * 60 * 60 * 24))),
        hours: this._formatNumber(Math.floor((timeDifference / (1000 * 60 * 60)) % 24)),
        minutes: this._formatNumber(Math.floor((timeDifference / 1000 / 60) % 60)),
        seconds: this._formatNumber(Math.floor((timeDifference / 1000) % 60)),
      };

      this.daysPlaceholder.innerHTML = intervals.days;
      this.hoursPlaceholder.innerHTML = intervals.hours;
      this.minutesPlaceholder.innerHTML = intervals.minutes;
      this.secondsPlaceholder.innerHTML = intervals.seconds;

      setTimeout(() => {
        this.display.classList.add('countdown__display--loaded');
      }, 1);
    } else {
      if (this.completeMessage && this.messagePlaceholder) {
        this.messagePlaceholder.classList.add('countdown__timer-message--visible');
      }

      if (this.hideTimerOnComplete === 'true') {
        this.display.classList.remove('countdown__display--visible');
        this.display.classList.add('countdown__display--hidden');
      }

      if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
        this.block.classList.add('countdown__block--hidden');
      }

      this.timerComplete = true;
    }
  }

  _formatNumber(number) {
    return number < 10 ? '0' + number : number;
  }
}

customElements.define('countdown-timer', CountdownTimer);
 
class Redirector {
  constructor() {
      this.defaultStatusCode = 302; 
  }

  /**
   * Redirects from one specific URL or path to another.
   * @param {string} fromUrl - The URL or path to match for redirection.
   * @param {string} toUrl - The URL or path to redirect to.
   */
  redirect(fromUrl, toUrl) {
    try {
        const currentUrl = window.location.href;
        const currentPath = window.location.pathname;
        
        const isFullFromUrl = fromUrl.startsWith('http');
        const isFullToUrl = toUrl.startsWith('http');

        const fromMatch = isFullFromUrl ? currentUrl === fromUrl : currentPath === fromUrl;
        const redirectTo = isFullToUrl ? toUrl : `${window.location.origin}${toUrl}`;

        if (fromMatch) {
            console.log(`Redirecting from ${fromUrl} to ${redirectTo}`);
            window.location.replace(redirectTo);
        }
    } catch (error) {
        this.handleError(error);
    }
  }

  /**
   * Validates the given URL.
   * @param {string} url - The URL to validate.
   * @returns {boolean} - True if the URL is valid, false otherwise.
   */
  isValidUrl(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch (_) {
        return false;
    }
  }

  /**
   * Handles errors that occur during the redirection process.
   * @param {Error} error - The error to handle.
   */
  handleError(error) {
    console.error(`Redirect failed: ${error.message}`);
  }
}


function zoom() {
  let zoom = document.querySelector(".product-gallery__zoom button");
  let galleryImages = document.querySelectorAll(".product-gallery__media");
  if (!zoom) return;

  galleryImages.forEach((image) => {
    image.addEventListener("click", function () {
      zoom.click();
    });
  });
}

function triggerQtyChangeEvent(event, element) {
  const changeEvent = new Event(event, { bubbles: true });
  element.dispatchEvent(changeEvent);
}

function qtyChange() {
  let btns = document.querySelectorAll('#cart-drawer .quantity-selector__button');

  btns.forEach(btn => {
    btn.addEventListener('click', function(){
      console.log('click work')
      let input = this.closest('.qty-box').querySelector('.quantity-input');
      setTimeout(function(){ triggerQtyChangeEvent('change', input); },500);
    });
  });   
}

function arrive(selector, callback, find) {
  const observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList") {
        const element = document.querySelector(selector);
        if (
          element &&
          element.shadowRoot &&
          element.shadowRoot.querySelector(find)
        ) {
          callback(element.shadowRoot);
          observer.disconnect();
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function razorpayWidget() {
  if (!document.body.classList.contains("template-product")) return;

  const selector = "main-component";

  const styleElement = document.createElement("style");

  const cssText = `
      .container {
        max-width: 450px !important;
      }
    `;

  styleElement.textContent = cssText;

  arrive(selector, (shadowRoot) => {
    shadowRoot.appendChild(styleElement);
  }, '.container');
}


// document.addEventListener('variant:change', function(v){
  
//   let container = document.getElementById('selectedVariantInfo');

//   if(!container) return;

//   let op1 = v.detail.variant.option1;
//   let op2 = v.detail.variant.option2;
//   let op3 = v.detail.variant.option3;

//   let option_1 = container.querySelector('.option-1');
//   let option_2 = container.querySelector('.option-2');
//   let option_3 = container.querySelector('.option-3');

//   if(option_1) { option_1.innerText = op1; } 
//   if(option_2) { option_2.innerText = op2; } 
//   if(option_3) { option_3.innerText = op3; }   
// });

function klaviyoReview() {
  let reviewItems = document.querySelectorAll('#overallRating');

  if(!reviewItems.length) return;

  reviewItems.forEach(function(reviewItem){
    let review = reviewItem.querySelector('.kl_reviews__star_rating_widget')?.getAttribute('aria-label');
    console.log(review)
  });
}

document.addEventListener("DOMContentLoaded", function () {
  zoom();
  klaviyoReview();

  const redirector = new Redirector();

  redirector.redirect('/collections/shop-all', '/pages/shop-all');
  redirector.redirect('/collections/iphone-case', '/pages/iphone-cases-accessories');
  redirector.redirect('/collections/iphone-accessories', '/pages/iphone-cases-accessories');
  redirector.redirect('/collections/watch-accessories', '/pages/watch-accessories');
  redirector.redirect('/collections/leather-cases', '/pages/leather-cases');
  redirector.redirect('/collections/work-essentials', '/pages/work-essentials');
}); 

